import {NestedFrameSlot} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/nestedFrameSlot/NestedFrameSlot';
import {
    AnySheet,
    SheetColumnName,
    SheetName
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';
import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {Workbook} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/Workbook';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

export class NestedSheet extends AnySheet
{
    public frame:IFrame;

    private constructor()
    {
        super();
    }

    public static create(id:SheetId,
                         workbook:Workbook,
                         name:SheetName,
                         columnNames:Array<SheetColumnName> = [],
    ):NestedSheet
    {
        const sheet:NestedSheet = new NestedSheet();

        sheet.id = id;
        sheet.workbook = workbook;
        sheet.name = name;
        sheet.columnNames = columnNames;

        return sheet;
    }

    public clone():NestedSheet
    {
        const clonedSheet:NestedSheet = new NestedSheet();

        clonedSheet.id = IdUtil.newGUID();
        clonedSheet.workbook = this.workbook;
        clonedSheet.name = this.name;

        return clonedSheet;
    }

    public get isCloud():boolean
    {
        return false;
    }

    public getSlotByLocation(location:SlotLocation):NestedFrameSlot | null
    {
        if( !location )
            return null;

        const cell = this.frame.getCellByOffset(location.colIndex, location.rowIndex);

        if( cell === null ) return null;

        if( !(window as any).__getSlotByLocation ) (window as any).__getSlotByLocation = 1;
        (window as any).__getSlotByLocation++;

        return NestedFrameSlot.create(
            this,
            cell,
            location,
        );
    }

    public getNumOfCells():number
    {
        return this.frame.recordCount * this.frame.fieldCount;
    }
}
